import InCardStack from 'components/atoms/container/InCardStack'
import AddRatersDescriptions from 'components/molecules/assessments/AddRatersDescriptions'
import AddRatersCard from './AddRatersCard'
const AddRaterPageCard = ({ fromSelfAssessment, goalId, assessmentData }) => {
  return (
    <InCardStack paddingTop={16} spacing={16} data-testid='add-raters-card'>
      <AddRatersDescriptions />
      <AddRatersCard
        fromSelfAssessment={fromSelfAssessment}
        goalId={parseInt(goalId, 10)}
        data={assessmentData}
        buttonDirection='column'
      />
    </InCardStack>
  )
}

export default AddRaterPageCard
